"use client"; // Error components must be Client Components

import { Container, Typography } from "ct-design";
import { useEffect } from "react";
import NoResults from "src/icons/noResults.svg";
export default function Error({
  error,
}: // reset,
{
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);

  return (
    <Container
      className="flex flex-column w-100p flex-middle"
      css={{ marginTop: "100px" }}
    >
      <NoResults />
      <Typography variant="HD3" className="mt-8">
        Some of our services are currently down
      </Typography>
      <Typography className="mt-3" variant="P2">
        We are working hard to get our systems up and running at the earliest.
      </Typography>
    </Container>
  );
}
